import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '电影', to: '/category/电影' },
  { label: '电视剧', to: '/category/电视剧' },
  { label: '综艺', to: '/category/综艺' },
  { label: '动漫', to: '/category/动漫' },
  { label: '影视资讯', to: '/news' },
];

const friendLinks = ['极光影院指南', '影迷手册', '周末片单社', '动漫情报站', '追剧日历'];

const socials = [
  { icon: 'ri-weibo-line', label: '微博' },
  { icon: 'ri-wechat-line', label: '微信' },
  { icon: 'ri-bilibili-line', label: '哔哩哔哩' },
  { icon: 'ri-tiktok-line', label: '抖音' },
];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-secondary-100">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-primary-400 to-accent-500 text-background-50">
                <i className="ri-movie-2-line text-xl" />
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">蜜桃网</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              蜜桃网致力于为影视爱好者提供最新电影、电视剧资讯与影视资源推荐，覆盖多类型影视剧集，帮助你快速发现想看的好内容。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-foreground-950">快速导航</h3>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-foreground-950">友情链接</h3>
            <ul className="mt-4 space-y-3">
              {friendLinks.map((link) => (
                <li key={link}>
                  <span className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-700">
                    {link}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-foreground-950">关注我们</h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              第一时间获取最新影视资讯与片单推荐。
            </p>
            <div className="mt-4 flex flex-wrap gap-3">
              {socials.map((s) => (
                <span
                  key={s.icon}
                  title={s.label}
                  className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${s.icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300/60 pt-6 text-sm text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 蜜桃网 · 影视资讯与资源推荐平台 · 本站为演示项目，内容仅供学习交流</p>
          <p className="flex flex-wrap gap-x-4 gap-y-1">
            <span className="cursor-pointer transition-colors hover:text-primary-700">关于我们</span>
            <span className="cursor-pointer transition-colors hover:text-primary-700">免责声明</span>
            <span className="cursor-pointer transition-colors hover:text-primary-700">版权声明</span>
          </p>
        </div>
      </div>
    </footer>
  );
}